import { ArbitraryTypedObject, PortableTextBlock } from '@portabletext/types'

export type PortableTextBodyElement = PortableTextBlock | ArbitraryTypedObject

export const portableTextToPlainText = (
  blocks: PortableTextBodyElement[],
  delimiter = '\n\n'
): string =>
  blocks
    .filter(block => block._type === 'block' && block.children?.length)
    .map(block => block.children.map(child => child.text).join(''))
    .join(delimiter)
